import 'react-app-polyfill/ie11';
import 'es5-shim';
import 'es6-shim';
import 'es7-shim';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { MuiThemeProvider } from '@material-ui/core/styles';

import 'config/polyfills';

import './config/i18n';
import { unregister } from './config/registerServiceWorker';
import store from './redux/store';
import App from './app';
import { muiTheme } from './styles';

unregister();

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider theme={muiTheme}>
      <App />
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('root')
);
